/**
 * sessionStorage keys for the in-progress security-check run snapshots
 * (issues #344/#345/#412). These persist the agent's Pass/Fail selections,
 * knowledge/choose-group progress and 2FA progress across a same-tab round trip
 * (e.g. the EDS-High "Check Transactions" navigation) and, on an online call,
 * a return to the same/another security variant within the SAME conversation.
 *
 * They are the single source of truth for the keys — the security screens
 * import them from here rather than redefining the literal — so Clear Session
 * (`clearAllSecurityRunSnapshots`) and the screens can never drift apart.
 */
export const SECURITY_RUN_SNAPSHOT_KEY = 'ptsb.securityRunSnapshot';
export const ECL_HIGH_RUN_SNAPSHOT_KEY = 'ptsb.eclHighSecurityRunSnapshot';

/**
 * Removes every persisted in-progress security-run snapshot.
 *
 * Called by App's Clear Session (CCF-10, #780): a clear-down re-authenticates
 * the customer from scratch, so any in-progress security answers must not
 * survive it. On an online journey Clear Session keeps the same conversation id
 * (#251) and the snapshot restore is keyed on that id, so without this a
 * re-entry to a security screen for the same customer re-populated the previous
 * answers. Wiping the snapshots here guarantees the security screens start with
 * a blank slate after a clear-down.
 */
export function clearAllSecurityRunSnapshots(): void {
  try {
    sessionStorage.removeItem(SECURITY_RUN_SNAPSHOT_KEY);
    sessionStorage.removeItem(ECL_HIGH_RUN_SNAPSHOT_KEY);
  } catch {
    // Non-fatal: storage may be unavailable (private mode).
  }
}
